import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, Phone } from 'lucide-react';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setIsMobileMenuOpen(false); }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Destinations', path: '/destinations' },
    { name: 'Activities', path: '/activities' },
    { name: 'Accommodation', path: '/accommodation' },
    { name: 'Transfers', path: '/transfers' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/95 shadow-md' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 flex items-center justify-between h-20">
        <Link to="/"><img src="/images/logo.png" alt="Logo" className="h-14 w-auto" /></Link>
        <div className="hidden lg:flex items-center space-x-8">
          {navLinks.map((link) => (
            <Link key={link.name} to={link.path} className="text-sm font-medium hover:text-primary transition-colors">
              {link.name}
            </Link>
          ))}
        </div>
        <div className="hidden lg:flex items-center space-x-4">
          <Button asChild className="bg-primary text-white"><Link to="/booking?ref=peregrine_tours_and_safaris">Book Now</Link></Button>
        </div>
        <button className="lg:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-background p-4 space-y-4 flex flex-col">
          {navLinks.map((link) => <Link key={link.name} to={link.path}>{link.name}</Link>)}
          <Button asChild><Link to="/booking?ref=peregrine_tours_and_safaris">Book Now</Link></Button>
        </div>
      )}
    </nav>
  );
};